import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

export default function FontFamilyHeader({ family }) {
  return (
    <Helmet>
      {family?.isGoogleFont && <link href={family?.url} rel="stylesheet" />}
      {!family?.isGoogleFont && (
        <style type="text/css">{`
          @font-face {
            font-family: '${family?.name}';
            src: url(${family?.url}) format('woff2');
            font-style: normal;
          }
        `}</style>
      )}
    </Helmet>
  );
}

FontFamilyHeader.propTypes = {
  family: PropTypes.shape({
    family: PropTypes.string,
    isGoogleFont: PropTypes.bool,
    name: PropTypes.string,
    url: PropTypes.string,
  }),
};

FontFamilyHeader.defaultProps = {
  family: null,
};
